export default __webpack_public_path__ + "static/media/Group9243.d040f371.svg";